export default __webpack_public_path__ + "static/media/bigCircle.99363faa.png";